// extracted by mini-css-extract-plugin
export default {"edit_your_box":"gh","edit_box_title":"hh","subscription":"ih","byb":"jh","recommended_for_you_title":"kh","explore":"lh","recommended":"mh","go_back":"nh","wrapper":"oh","product_img":"ph","info":"qh","remove_btn":"rh"};
    if(module.hot) {
      // 1713809673512
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  